/**
 * Schema of TipoOcorrencia
 * @author Simpli CLI generator
 */
import {$, InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import ChecklistEntrega from '@/model/resource/ChecklistEntrega'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import CnpjBulkLog from '@/model/resource/CnpjBulklog'

export default (model: CnpjBulkLog): Schema => ({
    idCnpjBulklogPk: {
        content: model.idCnpjBulklogPk,
        editable: false,
    },

    nome: {
        content: model.nome,
        input: InputType.TEXT,
        meta: {
            required: true,
            selectall: true,
        },
    },

    cnpj: {
        content: model.cnpj,
        input: InputType.CNPJ,
        meta: {
            required: true,
            selectall: true,
        },
    },

    idCnpjFuncaoPk: {
        content:  model.tipoCnpjFuncao && model.tipoCnpjFuncao.descricao,
    },

    idTipoChecklistEntregaPkAlt: {
        content: [
            model.tipoCnpjFuncao && model.tipoCnpjFuncao.descricao,
            {
                component: RenderLabelValue,
                props: {

                    value: (model.tipoCnpjFuncao && model.tipoCnpjFuncao.descricao) || '',
                },
            },
        ],
        textContent: model.tipoCnpjFuncao && model.tipoCnpjFuncao.$tag || '',
        input: InputType.SELECT,
        meta: {
            required: true,
            selectall: true,
        },
    },

    ativo: {
        content: bool(model.ativo),
        input: InputType.CHECKBOX,
    },
})
